












































































import { Component, Emit, Mixins, Prop, PropSync } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import SaveButton from '@/components/SaveButton.vue'
import LiquorLicenseFields from '@/components/LiquorLicense/LiquorLicenseFields.vue'
import {LicenseInfo, licenseService} from './LiquorLicense/liquor-license'

@Component({
  components: {
    SaveButton,
    LiquorLicenseFields
  }
})
export default class LiquorLicense extends Mixins(IconsMixin, AuthMixin) {
  @Prop({ type: String, required: true })
  public companyId!: string

  @Prop({ type: Boolean, default: true })
  public saveButton!: boolean

  public $refs!: {
    form: HTMLFormElement
  }

  public showUploadForm = false
  public isSaving = false
  public isDownloading = false
  public licenseNumber = ''
  public existingFile: File | null = null
  public selectedFile: File | null = null
  public licenseInfo: LicenseInfo | false | null = null

  public errors: string[] = []

  public async mounted() {
    const licenseInfo = await licenseService.info(this.companyId)
    this.updateLicenseInfo(licenseInfo || false)
  }

  public toggleUploadForm(show: boolean) {
    if (show) {
      this.licenseNumber = this.licenseInfo ? this.licenseInfo.licenseNumber : ''
      this.selectedFile = this.existingFile
    }
    this.showUploadForm = show
  }

  @Emit('updateSelectedFile')
  public updateSelectedFile() {
    return this.selectedFile
  }

  public async save() {
    // early return if there is no image or image is invalid here, also display an error?
    if (!this.$refs.form.validate() || !this.selectedFile || !this.licenseNumber) {
      return
    }

    this.errors = []
    this.isSaving = true

    try {
      const licenseInfo = await licenseService.save(
        this.companyId,
        this.licenseNumber,
        this.selectedFile === this.existingFile && this.licenseInfo
          ? this.licenseInfo.fileId
          : this.selectedFile
      )
      this.updateLicenseInfo(licenseInfo)
      this.toggleUploadForm(false)
    } catch (err) {
      const errBody = err.response.data
      this.errors.push(errBody.message || 'An unknown error has occured')
    }

    this.isSaving = false
  }

  public async download() {
    if (!this.licenseInfo) {
      return
    }

    this.isDownloading = true
    await licenseService.download(this.companyId, this.licenseInfo.filename)
    this.isDownloading = false
  }

  private updateLicenseInfo(licenseInfo: LicenseInfo | false) {
    this.licenseInfo = licenseInfo
    this.existingFile = !!licenseInfo
      ? licenseService.placeholderFile(
        licenseInfo.filename,
        licenseInfo.mimeType,
        +licenseInfo.size,
        licenseInfo.createdAt
      )
      : null
  }
}
